import React from "react"
import { BoxProps, IconButtonProps } from "@chakra-ui/react"

import Icon from "@components/Icon/Icon"
import { NavigationButton } from "./Styles"

export interface CarouselNavigationProps extends Omit<IconButtonProps, "aria-label"> {
  direction: "prev" | "next"
}

const CarouselNavigation = React.forwardRef<HTMLButtonElement, CarouselNavigationProps>(
  ({ direction, transform, top = "50%", left = "5%", right = "5%", color = "white", ...buttonProps }, ref) => {
    const position: BoxProps = direction === "prev" ? { left } : { right }
    const ariaLabel = direction === "prev" ? "previous slide" : "next slide"

    return (
      <NavigationButton
        ref={ref}
        {...position}
        {...buttonProps}
        top={top}
        variant="icon"
        aria-label={ariaLabel}
        transform={`translateY(-${transform || top})`}
      >
        <Icon name={direction === "prev" ? "arrowLeft" : "arrowRight"} color={color} size={["17px", "22px"]} />
      </NavigationButton>
    )
  }
)

export default React.memo(CarouselNavigation)
